"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var restful_model_1 = __importDefault(require("./restful-model"));
var attributes_1 = __importDefault(require("./attributes"));
var Resource = /** @class */ (function (_super) {
    __extends(Resource, _super);
    function Resource(connection, props) {
        var _this = _super.call(this, connection, props) || this;
        _this.email = '';
        _this.name = '';
        _this.capacity = '';
        _this.building = '';
        _this.floorNumber = '';
        _this.initAttributes(props);
        return _this;
    }
    Resource.collectionName = 'resources';
    Resource.attributes = {
        object: attributes_1.default.String({
            modelKey: 'object',
            readOnly: true,
        }),
        email: attributes_1.default.String({
            modelKey: 'email',
        }),
        name: attributes_1.default.String({
            modelKey: 'name',
        }),
        capacity: attributes_1.default.String({
            modelKey: 'capacity',
            readOnly: true,
        }),
        building: attributes_1.default.String({
            modelKey: 'building',
            readOnly: true,
        }),
        floorName: attributes_1.default.String({
            modelKey: 'floorName',
            jsonKey: 'floor_name',
            readOnly: true,
        }),
        floorNumber: attributes_1.default.String({
            modelKey: 'floorNumber',
            jsonKey: 'floor_number',
            readOnly: true,
        }),
    };
    return Resource;
}(restful_model_1.default));
exports.default = Resource;
